import React, {useContext, useEffect} from "react";
import Box from "@amzn/meridian/box";
import {VIRTUAL_DEPART_DRIVER, VIRTUAL_DEPART_STORE} from "./constants/VirtualDepartDriverConstants";
import {VirtualDepartDriverContext} from "./context/VirtualDepartDriverContext";

export const VirtualDepartDriverResponse = ({checkedDriver}) => {
    const {virtualDepartDriverDispatch} = useContext(VirtualDepartDriverContext);

    useEffect(() => {
        /**
         * This is used to check whether it is store or not
         */
        if (checkedDriver.isStore) {
            virtualDepartDriverDispatch({
                type: VIRTUAL_DEPART_STORE,
                data: {
                    storeId: checkedDriver.storeId,
                    dispatcher: virtualDepartDriverDispatch
                }
            });
        } else {
            virtualDepartDriverDispatch({
                type: VIRTUAL_DEPART_DRIVER,
                data: {
                    driverId: checkedDriver.driverId,
                    dispatcher: virtualDepartDriverDispatch
                }
            });
        }
    }, []);

    return (<Box></Box>
    );
};


// WEBPACK FOOTER //
// ./src/components/virtualDepartDriver/VirtualDepartDriverReponse.js